<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i class="fas fa-star-half-alt"></i>
          {{ $t("public.views.Pages.Rating.vueTitle") }}
        </h4>
      </template>
      <template v-slot:headerAction>
        <b-button class="mr-2" style="right" variant="primary" @click="goToDashboard">{{
          $t("public.views.Pages.Rating.btnBack")
        }}
        </b-button>
        <b-button class="mr-2" style="right" variant="success" @click="store">{{
          $t("public.views.Pages.Rating.btnSave")
        }}
        </b-button>
      </template>
      <template v-slot:body>
        <tab-nav :tabs="true">
          <tab-nav-items v-for="(option, index) in rating.tabs" :id="'tab-nav-' + index" :key="index"
            :active="index < 1" :ariaSelected="true" :href="'#tab-' + index" role="tab">
            <template v-slot:title>
              {{ option.name }}
            </template>
          </tab-nav-items>
        </tab-nav>
        <tab-content>
          <tab-content-item v-for="(option, index) in rating.tabs" :id="'tab-' + index" :key="index"
            :active="index < 1">
            <div class="test-survey-builder">
              <b-row>
                <b-col v-for="(question, index) in option.questionsList" :key="index" :cols="12">
                  <div class="p-0">
                    <div class="question-section">
                      <p class="question_body">{{ question.body }}</p>
                    </div>
                    <div class="answer-section">
                      <div v-if="question.type === 'BOOLEAN'" class="option-section">
                        <b-form-group v-slot="{ ariaDescribedby }">
                          <b-form-radio v-for="(option, index) in question.options" :key="index"
                            v-model="question.value" :aria-describedby="ariaDescribedby" :disabled="readOnly"
                            :name="'booleanSelect' + question.uuid" :value="option.body">{{ option.body }}
                          </b-form-radio>
                        </b-form-group>
                      </div>
                      <div v-if="question.type === 'TEXT'" class="option-section">
                        <b-form-input v-if="question.characterLimited" v-model="question.value"
                          :maxlength="question.textLimit" :readonly="readOnly" min="0" type="text" />
                        <b-form-input v-if="!question.characterLimited" v-model="question.value" :readonly="readOnly"
                          type="text" />
                      </div>
                      <div v-if="question.type === 'FILE'" class="option-section">
                        <vue-dropzone :id="'dropzone' + question.uuid" :options="dropzoneOptions" @vdropzone-success="
                          vdropzoneSuccess(question, ...arguments)
                        "></vue-dropzone>
                      </div>
                      <div v-if="question.type === 'DATE'" class="option-section">
                        <date-picker v-model="question.valueTmp" :format="myFormat" :formatter="momentFormat"
                          :readonly="readOnly" type="date" @pick="updateDate(question)"></date-picker>
                      </div>
                      <div v-if="question.type === 'TIME'" class="option-section">
                        <vue-timepicker v-model="question.valueTmp" :readonly="readOnly"
                          @change="updateTime(question)"></vue-timepicker>
                      </div>
                      <div v-if="question.type === 'NUMBER'" class="option-section">
                        <div>
                          <b-form-input v-if="question.hasMinMax && !question.allowDecimals" v-model="question.value"
                            :max="question.maxValue" :min="question.minValue" :readonly="readOnly" type="range">
                            {{ question.value }}
                          </b-form-input>
                          <b-form-input v-if="!question.hasMinMax && question.allowDecimals" v-model="question.value"
                            :readonly="readOnly" step="0.01" type="number">
                          </b-form-input>
                          <b-form-input v-if="
                            !question.hasMinMax && !question.allowDecimals
                          " v-model="question.value" :readonly="readOnly" type="number">
                          </b-form-input>
                          <b-form-input v-if="question.hasMinMax && question.allowDecimals" v-model="question.value"
                            :max="question.maxValue" :min="question.minValue" :readonly="readOnly" step="0.01"
                            type="range">
                          </b-form-input>
                          <div v-if="question.hasMinMax">
                            {{ question.value }}
                          </div>
                        </div>
                      </div>
                      <div v-if="question.type === 'SINGLE_CHOICE'" class="option-section">
                        <b-form-group v-slot="{ ariaDescribedby }" @input="multiChoiceTransformJson(question)">
                          <b-form-radio v-for="(option, index) in question.options" :key="index"
                            v-model="question.value" :aria-describedby="ariaDescribedby" :disabled="readOnly"
                            :value="option.body" name="singleSelect">{{ option.body }}
                          </b-form-radio>
                        </b-form-group>
                      </div>
                    </div>
                    <div v-if="question.type === 'RATING'" class="option-section">
                      <b-form-rating :id="'rating' + question.uuid" v-model="question.value"
                        variant="warning"></b-form-rating>
                    </div>
                    <div v-if="question.type === 'TEXTAREA'" class="option-section">
                      <b-form-textarea :id="'textarea' + question.uuid" v-model="question.value" max-rows="6"
                        rows="3"></b-form-textarea>
                    </div>
                    <div v-if="question.type === 'EDITOR'" class="option-section">
                      <ckeditor :id="'ckeditor' + question.uuid" v-model="question.value" :config="configCK"
                        type="classic"></ckeditor>
                    </div>
                    <div v-if="question.type === 'MULTI_CHOICE'" class="option-section">
                      <b-form-group v-slot="{ ariaDescribedby }">
                        <b-form-checkbox-group v-model="question.valueTmp" @input="multiChoiceTransformJson(question)">
                          <b-form-checkbox v-for="(option, index) in question.options" :key="index"
                            :aria-describedby="ariaDescribedby" :name="'multiChoiceSelect' + question.uuid"
                            :value="option.sequence">{{ option.body }}
                          </b-form-checkbox>
                        </b-form-checkbox-group>
                      </b-form-group>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </tab-content-item>
        </tab-content>
      </template>
    </iq-card>
    <notifications group="notificacions" />
  </b-container>
  <!-- <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i class="fas fa-star-half-alt"></i> {{ $t("rating.vueTitle") }}
        </h4>
      </template>
      <b-row class=" mt-3">
        <b-col sm="2"></b-col>
        <h4 class="card-title">{{ $t("rating.title") }}</h4>
      </b-row>

      <rating-form
        :name="item.name"
        :id="item.id"
        v-model="variable[index]"
        v-for="(item, index) in ratingOptions"
        :key="index"
      ></rating-form>
      <b-row>
        <b-col sm="2"></b-col>
        <b-col sm="2">
          <label for="textarea-rating">{{ $t("rating.coment") }}</label>
        </b-col>
        <b-col sm="5">
          <b-form-textarea
            v-model="comments"
            id="textarea-rating"
          ></b-form-textarea>
          <b-button
            variant="success"
            class="pb-2 float-right mt-3"
            @click="store"
            >{{ $t("rating.btnSend") }}</b-button
          >
        </b-col>
      </b-row>
    </iq-card>
  </b-container> -->
</template>
<script>
import { xray } from "../../config/pluginInit";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";

import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

import RatingForm from "../../components/xray/rating/RatingForm";

import moment from "moment";

import RatingJson from "../../json/Rating";

import ratingService from "../../services/rating";
import organizationService from "../../services/organization";

export default {
  name: "Rating",
  components: { RatingForm, DatePicker, VueTimepicker },
  mounted() {
    xray.index();
    if (this.$route.query.reload && this.$route.query.reload === true) {
      this.$router.push({
        name: "auth.rating",
        query: { event: this.$route.query.event, reload: false },
      });
      location.reload();
    }
    this.getTemplateOrganization();
  },

  methods: {
    goToDashboard() {
      this.$router.push({
        name: "auth.patient.dashboard",
      });
    },
    questionaryToRating() {
      let self = this;
      if (this.rating && this.rating.tabs && this.rating.tabs.length !== 0) {
        this.rating.tabs.forEach(function (tab) {
          if (tab && tab.questionsList && tab.questionsList.length !== 0) {
            tab.questionsList.forEach(function (question) {
              let obj = {
                question: question.body === null ? "" : question.body,
                value: question.value === null ? "" : question.value,
              };
              self.variable.push(obj);
            });
          }
        });
      }
    },
    async getTemplateOrganization() {
      let self = this;

      this.$awn.asyncBlock(
        organizationService.getOrganizationValoration(this.organizationId),
        (response) => {
          if (response) {
            self.rating = response.data;
          }
        },
        (error) => {
          self.goToDashboard();
        },
        " "
      );
    },
    store() {
      let self = this;

      this.questionaryToRating();

      let obj = {
        ratingQuestions: this.variable,
        eventId: this.$route.query.event,
        questionaryId: this.rating.uuid,
      };

      this.$awn.asyncBlock(
        ratingService.create(obj),
        (response) => {
          if (response) {
            self.$router.push({
              name: "auth.patient.dashboard",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "ratingService.create",
            module: "view-pages-rating",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              obj: obj
            })
          });
        },
        " "
      );
    },
    vdropzoneSuccess: function (question, file, response) {
      question.value =
        process.env.VUE_APP_BASE_URL_CORE + "public/file/" + response.uuid;
    },
    multiChoiceTransformJson(question) {
      let str = "";
      if (
        question.valueTmp &&
        (question.type === "MULTI_CHOICE" ||
          question.type === "SINGLE_CHOICE" ||
          question.type === "BOOLEAN")
      ) {
        if (question.options && question.options.length !== 0) {
          question.options.forEach(function (option) {
            if (question.valueTmp.includes(option.sequence)) {
              if (str) {
                str = str + " - " + option.body;
              } else {
                str = option.body;
              }
            }
          });
        }

        question.value = str;
      }
    },
    updateTime(question) {
      if (question.valueTmp) {
        question.value = question.valueTmp.HH + ":" + question.valueTmp.mm;
      }
    },
    updateDate(question) {
      question.value = moment(question.valueTmp).format("DD/MM/yyyy");
    },
  },

  data() {
    return {
      organizationId: localStorage.getItem("organizationId"),
      //Form dynamic
      readOnly: false,
      configCK: {
        fillEmptyBlocks: false,
        basicEntities: false,
        entities: false,
        entities_greek: false,
        entities_latin: false,
        entities_additional: "",
        language: "es",
      },
      //vue2-data-picker
      myFormat: "DD/MM/YYYY",
      momentFormat: {
        //[optional] Date to String
        stringify: (date) => {
          return date ? moment(date).format("LL") : "";
        },
        //[optional]  String to Date
        parse: (value) => {
          return value ? moment(value, "LL").toDate() : null;
        },
        //[optional] getWeekNumber
        getWeek: (date) => {
          // a number
        },
      },
      dropzoneOptions: {
        url: process.env.VUE_APP_BASE_URL_CORE + "public/file/upload",
        thumbnailWidth: 200,
        maxFilesize: 2,
        addRemoveLinks: true,
        maxFiles: 1,
        dictDefaultMessage: "<i class='ri-upload-cloud-fill'></i>Subir",
      },
      //----
      rating: {},
      badge: {
        color: null,
        text: null,
      },
      ratingOptions: RatingJson,
      variable: [],
      comments: "",
    };
  },
};
</script>
